module.exports = __webpack_public_path__ + "img/icon_test_device.d5026aa4.png";